/* GENERATED by scripts/gen-data.mjs — film scene "f-drift" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_DRIFT: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "ch",
      "x": 14,
      "y": 34,
      "w": 392,
      "h": 236,
      "lKey": "films:f-drift.items.ch.l"
    },
    {
      "k": "spark",
      "id": "sp",
      "x": 52,
      "y": 64,
      "w": 296,
      "h": 172,
      "pts": [
        0.95,
        0.94,
        0.95,
        0.93,
        0.9,
        0.86,
        0.8,
        0.74,
        0.71,
        0.68
      ]
    },
    {
      "k": "note",
      "id": "ya",
      "x": 354,
      "y": 56,
      "lKey": "films:f-drift.items.ya.l"
    },
    {
      "k": "note",
      "id": "yb",
      "x": 354,
      "y": 214,
      "lKey": "films:f-drift.items.yb.l"
    },
    {
      "k": "note",
      "id": "yc",
      "x": 52,
      "y": 244,
      "lKey": "films:f-drift.items.yc.l"
    },
    {
      "k": "box",
      "id": "rt",
      "x": 424,
      "y": 40,
      "w": 150,
      "h": 56,
      "lKey": "films:f-drift.items.rt.l"
    },
    {
      "k": "box",
      "id": "hq",
      "x": 424,
      "y": 120,
      "w": 150,
      "h": 56,
      "lKey": "films:f-drift.items.hq.l"
    },
    {
      "k": "box",
      "id": "th",
      "x": 424,
      "y": 200,
      "w": 150,
      "h": 56,
      "lKey": "films:f-drift.items.th.l",
      "sKey": "films:f-drift.items.th.s"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "th",
      "to": "sp",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "sp",
      "to": "rt",
      "dash": true
    }
  ],
  "steps": [
    {
      "on": [
        "ch",
        "sp",
        "ya",
        "yb",
        "yc"
      ],
      "hot": [
        "sp"
      ],
      "capKey": "films:f-drift.steps.0.cap"
    },
    {
      "on": [
        "ch",
        "sp",
        "th",
        "w1"
      ],
      "hot": [
        "th",
        "w1"
      ],
      "capKey": "films:f-drift.steps.1.cap"
    },
    {
      "on": [
        "ch",
        "sp",
        "th",
        "w1",
        "hq"
      ],
      "hot": [
        "hq"
      ],
      "capKey": "films:f-drift.steps.2.cap"
    },
    {
      "on": [
        "ch",
        "sp",
        "th",
        "w1",
        "hq",
        "rt",
        "w2"
      ],
      "hot": [
        "rt",
        "w2"
      ],
      "capKey": "films:f-drift.steps.3.cap"
    }
  ]
};
